import { useContext } from "react";
import { RecordingActivityContext } from "./RecordingActivityContext";

export const useRecordingActivity = () => useContext(RecordingActivityContext);
